import type { SVGProps } from "react";
export function CheckCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m.833252 8.00004c0-3.95804 3.208628-7.166666 7.166668-7.166666 3.95808 0 7.16668 3.208626 7.16668 7.166666 0 3.95806-3.2086 7.16666-7.16668 7.16666-3.95804 0-7.166668-3.2086-7.166668-7.16666zm7.166668-6.16667c-3.40576 0-6.16667 2.76092-6.16667 6.16667 0 3.40576 2.76091 6.16666 6.16667 6.16666 3.40578 0 6.16668-2.7609 6.16668-6.16666 0-3.40575-2.7609-6.16667-6.16668-6.16667zm3.86558 2.71011c.2167.17123.2535.48567.0822.70231l-4.64511 5.87701c-.2194.286-.56287.4491-.92331.4383-.35997-.0107-.69273-.1937-.89473-.4915l-1.44891-2.05623c-.15906-.22573-.10501-.53766.12073-.69673.22573-.15907.53766-.105.69672.12073l1.45185 2.06043.00677.0098c.02185.0327.05815.0528.09743.054s.07671-.0167.10048-.048l.00589-.0076 4.64769-5.88029c.1713-.21664.4857-.25346.7023-.08223z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
